import React from 'react';
import './SuccessPageStripe.css';
import {FcCheckmark} from "react-icons/fc";
import {Button} from "./Button";
import {useTranslation} from '../i18n/LanguageProvider';

export const SuccessPageStripe = () => {
    const {t} = useTranslation();
    return (
        <div className={'SuccessPage-container'}>
            <div className={'SuccessPage-header'}>
                <div className={'SuccessPage-checkmark'}>
                    <FcCheckmark
                        color={'#659C3A'}
                        size={25}
                    />
                </div>
                <h1 className={'SuccessPage-title'}>
                    {t('success.title')}
                </h1>
            </div>
            <span className={'SuccessPage-subtitle'}>
                {t('success.subtitle')}
            </span>
            <span className={'SuccessPage-subtitle'}>
              {t('successStripe.cancel.prefix')}
                <a target="_blank" rel="noreferrer" href='https://billing.stripe.com/p/login/28E3cwa1FaEZ3ZpePpcQU00'>
                    {t('successStripe.cancel.link')}
                </a>
                {t('successStripe.cancel.middle')}
                <a target="_blank" rel="noreferrer" href={'https://t.me/anonchatsupport'}>
                    {t('successStripe.cancel.support')}
                </a>
                {t('successStripe.cancel.suffix')}
            </span>
            <Button
                onClick={() => window.location.replace('https://anonchat.com')}
                title={t('actions.goHome')}
            />
            <span className={'SuccessPage-subtitle-footer'}>
                {t('support.contactPrefix')}
                <a target="_blank" rel="noreferrer" href={'https://anonchat.com/app'}>{t('support.anonchatLinkLabel')}</a>
                {t('support.contactMiddle')}
                <a target="_blank" rel="noreferrer" href={'https://t.me/anonchatsupport'}>{t('support.telegramLinkLabel')}</a>
            </span>
        </div>
    );
};
